import { RoutePermittedRole } from "shared/constants/AppConst";
import Plan from "./plan";
import PlanIndex from "./plan/PlanCreate";
import PlanUpdateIndex from "./plan/PlanUpdate";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const planConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/planMaster/ViewPlan/",
    exact: true,
    element: isModuleAuthorized("View Plan") ? <Plan /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/planMaster/ViewPlan/plan/",
    exact: true,
    element: isModuleAuthorized("View Plan") ? <Plan /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/planMaster/ViewPlan/PlanCreate/",
    exact: true,
    element: isModuleAuthorized("View Plan") ? <PlanIndex /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/planMaster/viewPlan/planUpdate/:planId/",
    exact: true,
    element: isModuleAuthorized("Edit Plan") ? <PlanUpdateIndex /> : <Error403 />,
  },
];
